import LoginComponent from '../components/auth/login';

export default function Login() {
  return <LoginComponent />;
}
